__turbopack_context__.v({
  "wrapper": "Breadcrumbs-module-scss-module__EaI_2W__wrapper",
});
